import React, { useState } from "react";


const CustomSlider = ({ onChange }) => {
  const [value, setValue] = useState(9); // 初始值设置为 9

  const handleChange = (event) => {
    const newValue = Number(event.target.value);
    setValue(newValue);
    onChange(newValue); // 将值传递给父组件
  };

  return (
    <div className="slider-container">
      {/* 数字刻度 */}
      <div className="slider-labels">
        {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
          <span
            key={num}
            className={`slider-label ${num === value ? "active" : ""}`}
          >
            {num}
          </span>
        ))}
      </div>

      {/* 滑块 */}
      <input
        type="range"
        min="1"
        max="10"
        step="1"
        value={value}
        onChange={handleChange}
        className="slider"
        style={{
            background: `linear-gradient(to right, rgba(0, 121, 107, 0.2) 0%, rgba(0, 121, 107, 1) ${
              ((value - 1) / 9) * 100
            }%, #e0e0e0 ${((value - 1) / 9) * 100}%)`,
          }}
      />

    </div>
  );
};

export default CustomSlider;
